import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Styles from "./RiderChat.module.scss";
import { IoIosSend } from "react-icons/io";

const RiderChat = ({ open, handleClose, closemodal, width, bgcolor }) => {
  const [text, setText] = useState([
    {
      user: { agent: 1 },
      text: "Hello, is my order on the way?",
      createdAt: Date.now() - 60000,
    },
    {
      user: { agent: 2 },
      text: "Yes, your order is on its way!",
      createdAt: Date.now() - 30000,
    },
  ]);

  const [newMessage, setNewMessage] = useState("");

  let agentId = { id: 1 }; // Dummy agent ID

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  const sendMessage = () => {
    if (newMessage.trim() !== "") {
      const message = {
        user: { agent: agentId.id },
        text: newMessage,
        createdAt: Date.now(),
      };
      setText([...text, message]);
      setNewMessage("");
    }
  };

  return (
    <Modal open={open} onClose={handleClose} className={Styles.modal}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: width,
          bgcolor: bgcolor,
          borderRadius: "15px",
          boxShadow: "1px 2px 10px 5px rgba(112, 144, 176, 0.1)",
          p: 4,
        }}
      >
        <div onClick={closemodal}>
          <button className={Styles.close}>X</button>
          <h1 className={Styles.header}>CHAT</h1>
        </div>

        <div className={Styles.chatContainer}>
          {text.map((message, index) => (
            <div key={index} className={Styles.messageContainer}>
              {message.user.agent === agentId.id ? (
                <div className={Styles.rp}>
                  <div className={Styles.replyText}>{message.text}</div>
                  <div>{new Date(message.createdAt).toLocaleTimeString()}</div>
                </div>
              ) : (
                <div className={Styles.rc}>
                  <div className={Styles.receivedText}>{message.text}</div>
                  <div>{new Date(message.createdAt).toLocaleTimeString()}</div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className={Styles.inputContainer}>
          <textarea
            placeholder="Type a message..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <div className={Styles.icon} onClick={sendMessage}>
            <IoIosSend />
            <span className={Styles.tooltip}>Send Message</span>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default RiderChat;
